import { combineReducers } from 'redux';
// reducers
import { user } from './User/UserReducers';
import { pageLayout } from './Layouts/LayoutReducers';
import { plans } from './Plans/PlansReducers';
import { subscription } from './Subscriptions/SubscriptionsReducers';
import { payments } from './Payments/PaymentReducers';
import { paymentMethods } from './PaymentMethods/PaymentMethodReducers';
import { checkout } from './Checkout/CheckoutReducers';
import { tracking } from './Tracking/TrackingReducers';
import { freeForm } from './FreeForm/FreeFormReducers';
import { appConfig } from './AppConfig/AppConfigReducers';
import { purchaseMode } from './PurchaseMode/PurchaseModeReducers';
import { promoCode } from './PromoCode/PromoCodeReducers';
import { secondScreen } from './SecondScreen/SecondScreenReducers';
import { integrations } from './Integrations/IntegrationsReducers';
import { contentCards } from './BrazeContentCards/ContentCardsReducer';

// combine
const reducers = combineReducers({
  appConfig,
  checkout,
  freeForm,
  integrations,
  pageLayout,
  payments,
  paymentMethods,
  plans,
  promoCode,
  purchaseMode,
  secondScreen,
  subscription,
  tracking,
  user,
  contentCards,
});

export default reducers;
